import * as React from "react";

function SvgManualMode(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={27} cy={27} r={26.5} stroke="#fff" />
      <path viewBox="0 0 54 54"
        fillRule="evenodd"
        clipRule="evenodd"
        d="m 6.9644949,16.349177 h 1.3558997 l 1.6949004,2.0339 1.695,-2.0339 h 1.3559 v 10.1694 h -1.3559 v -8.1355 l -1.695,2.0338 -1.6949004,-2.0338 v 8.1355 H 6.9644949 Z m 10.1695001,0 h -0.678 l -2.7118,10.1694 h 1.3559 l 0.339,-1.3559 h 2.7118 l 0.339,1.3559 h 1.356 z m -1.3559,7.4576 1.0169,-4.4068 1.017,4.4068 z m 21.6949,-7.4576 h -0.678 l -2.7119,10.1694 h 1.356 l 0.339,-1.3559 h 2.7118 l 0.339,1.3559 h 1.3559 z m -1.356,7.4576 1.017,-4.4068 1.0169,4.4068 z m -7.4576,-7.4576 h -1.3559 v 8.8135 l 1.3559,1.3559 h 3.3898 l 1.356,-1.3559 v -8.8135 h -1.356 v 8.1355 l -0.6779,0.678 h -2.0339 l -0.678,-0.678 z m -5.0847,11.5254 h 1.6949 l 0.678,0.6779 0.6779,0.678 v 7.4576 l -1.3559,1.356 h -3.3898 l -1.356,-1.356 v -7.4576 l 0.678,-0.678 0.678,-0.6779 z m -1.017,1.3559 -0.6779,0.678 v 6.1017 l 0.6779,0.6779 h 2.0339 l 0.678,-0.6779 v -6.1017 l -0.678,-0.678 z m -7.4576,-1.3559 h -1.3559 v 10.1695 h 1.3559 v -8.1356 l 1.6949,2.0339 1.6949,-2.0339 v 8.1356 h 1.356 v -10.1695 h -1.356 l -1.6949,2.0339 z m 12.2034,0 v 10.1695 h 4.7457 l 1.356,-1.356 v -7.4576 l -1.356,-1.3559 z m 1.3559,1.3559 h 2.7119 l 0.6779,0.678 v 6.1017 l -0.6779,0.6779 h -2.7119 z m 5.4237,-1.3559 v 10.1695 h 6.1017 v -1.356 h -4.7457 v -3.3898 h 4.7457 v -1.3559 h -4.7457 v -2.7119 h 4.7457 v -1.3559 z m 8.1356,-11.5254 h -1.3559 v 10.1694 h 6.1017 v -1.3559 h -4.7458 z m -21.6949,0 h 1.356 l 3.3898,7.1186 v -7.1186 h 1.3559 v 10.1694 h -1.3559 l -3.3898,-6.7796 v 6.7796 h -1.356 z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgManualMode;
